import React from 'react'

const MyAgendaContext = React.createContext({
    userAgenda: [],
    setUserAgenda: () => {},
    toggleMyagenda: () => {}
})
export const MyAgendaProvider = MyAgendaContext.Provider
export default MyAgendaContext